function applyImageClassChanges() {
  const wrappers = document.querySelectorAll(
    '.ab-editorial-grid .spf-product-card__image-wrapper'
  );

  wrappers.forEach(wrapper => {
    const images = wrapper.querySelectorAll('img');
    if (images.length === 0) return;

    // Primero quitar clases de todos
    images.forEach(img => {
      img.classList.remove(
        'spf-product-card__image-main',
        'spf-product-card__image-secondary'
      );
      img.classList.add('spf-product-card__image-hidden');
    });

    // Después reasignar main y secondary
    setTimeout(() => {
      const imgMain = wrapper.querySelector('img:nth-child(2)');
      if (imgMain) {
        imgMain.classList.add('spf-product-card__image-main');
        imgMain.classList.remove('spf-product-card__image-hidden');
      }

      const imgSecondary = wrapper.querySelector('img:nth-child(3)');
      if (imgSecondary) {
        imgSecondary.classList.add('spf-product-card__image-secondary');
        imgSecondary.classList.remove('spf-product-card__image-hidden');
      }

      const imgOrg = wrapper.querySelector('img:first-child');
      const imgOrgSecond = wrapper.querySelector('img:nth-child(2)');
      if (!imgSecondary && !imgMain) {
        imgOrg.classList.add('spf-product-card__image-main');
        imgOrg.classList.remove('spf-product-card__image-hidden');
        imgOrgSecond.classList.add('spf-product-card__image-secondary');
        imgOrgSecond.classList.remove('spf-product-card__image-hidden');
      }
    }, 200);
  });
}

window.addEventListener('load', () => {
  applyImageClassChanges();
});

(function () {
  let lastUrl = location.href;

  const observeUrlChange = function () {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      setTimeout(() => {
        applyImageClassChanges();
      }, 800);
    }
  };

  const pushState = history.pushState;
  history.pushState = function () {
    pushState.apply(history, arguments);
    observeUrlChange();
  };

  const replaceState = history.replaceState;
  history.replaceState = function () {
    replaceState.apply(history, arguments);
    observeUrlChange();
  };

  window.addEventListener('popstate', observeUrlChange);

  const observer = new MutationObserver(observeUrlChange);
  observer.observe(document.body, { childList: true, subtree: true });
})();